import React from 'react';
import SearchablePicker from '../../master/SearchablePicker';
import Input from '../../master/Input';
import { useTranslation } from 'react-i18next';
import { getDirection } from '../../../utils/functions';

export default function ExpertInfoEdit({ data, changeData }) {
    const { t, i18n } = useTranslation();
    return (
        <>
            <SearchablePicker
                label={t('Marital status')}
                value={data.maritalStatus}
                data={[
                    t('Single'),
                    t('Married'),
                ]}
                rtl={getDirection(i18n.language) ==='rightToLeft'}
                onSelect={status => changeData(status, 'maritalStatus') }
                disabled={data.fix_change}
            />
            <Input
                label={t('Emergency contact number')}
                value={data.emergencyPhone}
                isLTR={getDirection(i18n.language) ==='leftToRight'}
                mode='numeric'
                onChange={value => changeData(value, 'emergencyPhone')}
                disabled={data.fix_change}
            />
            <Input
                col={12}
                isLTR={getDirection(i18n.language) ==='leftToRight'}
                label={t('Complete postal address')}
                value={data.address}
                onChange={value => changeData(value, 'address')}
                disabled={data.fix_change}
            />
        </>
    );
}
